const PLACEHOLDER = 'https://via.placeholder.com/450x250'
const ALT = 'placeholder image'


const FeaturedCollections = ({ data }) => {
    // console.log('data in FeaturedCollections', data)
    return (
        <div className="featured-collections-outer">
            <div className="featured-collections-inner">
                <div className="featured-collections-header">
                    <h2>Our Featured Collections</h2>
                    <span className="header-line"></span>
                </div>
                <ul className="nostyle featured-collections">
                    {data.collections.map((c) => {
                        return (
                            <li className="featured-collection" key={c.id}>
                                <div className="collection-image">
                                    <a href={c.collectionSlug}>
                                        <img
                                            src={c.collectionImageSrc ? c.collectionImageSrc : PLACEHOLDER}
                                            alt={c.collectionImageAlt ? c.collectionImageAlt : ALT}
                                        />
                                    </a>
                                </div>
                                <div className="collection-content">
                                    <h3>{c.collectionTitle}</h3>
                                    <a href={c.collectionSlug}>SHOP</a>
                                </div>

                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default FeaturedCollections
